import { getStageWindow, findStageById } from './processHelpers.js';
import APP_STATES from '../enums/AppStates.js';

const FEATURE_STAGE = {
  evidences: 'D6B65F70-E3B6-4668-AAED-DEC7044D5EB0',
  evaluacion: '6AE487ED-3106-4FC1-B2FE-5F1DB9F998C8',
};

const ALWAYS_ENTER = new Set(['home', 'kpi', 'vision']);

export function getFeatureAccess(feature, { process, user, now = new Date() } = {}) {
  const state = process.estado.Id.toUpperCase()

  // 1) features siempre accesibles
  if (ALWAYS_ENTER.has(feature)) {
    return { canEnter: true, canEdit: false, readOnly: feature === 'vision', reason: 'always' };
  }

  // 2) si no hay proceso seleccionado
  if (!process?.Id) return { canEnter: false, canEdit: false, readOnly: false, reason: 'no-process' };

  // 3) BORRADOR: bloquear etapas
  if (state === APP_STATES.BORRADOR) {
    return { canEnter: false, canEdit: false, readOnly: false, reason: 'draft' };
  }

  // 4) HISTÓRICO: entrar sí, solo lectura
  if (state === APP_STATES.HISTORICO) {
    return { canEnter: true, canEdit: false, readOnly: true, reason: 'historical' };
  }

  // 5) ACTIVO: gobernado por fechas de su etapa
  if (state === APP_STATES.ACTIVO) {
    const wanted = FEATURE_STAGE[feature];           // p.ej. 'GESTION DE EVIDENCIAS'
    const stage = findStageById(process, wanted);  // match por nombre/id normalizado
    const { phase, inside } = getStageWindow(stage, now);

    if (phase === null)  return { canEnter: false, canEdit: false, readOnly: false, reason: 'no-stage' };
    if (phase === -1)  return { canEnter: false, canEdit: false, readOnly: false, reason: 'before' };
    if (phase === 0)  return { canEnter: true,  canEdit: true,  readOnly: false, reason: 'inside' };
    // phase === 'after'
    return { canEnter: true,  canEdit: false, readOnly: true,  reason: 'after' };
  }

  return { canEnter: false, canEdit: false, readOnly: false, reason: 'unknown-state' };
}
